<template>
  <div class="goodList">
    <router-link
      :to="{ path: '/detail/' + item.id }"
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in goodList"
      :key="index">
      <div class="pictrue">
        <img :src="item.image
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',$t('message.img.goods_img_10'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',$t('message.img.goods_img_50'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',$t('message.img.goods_img_5'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',$t('message.img.goods_img_150'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',$t('message.img.goods_img_25'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',$t('message.img.goods_img_500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',$t('message.img.goods_img_1500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',$t('message.img.goods_img_2500'))" class="image" />
        <img
          src="@assets/images/one.png"
          class="numPic"
          v-if="isSort === true && index === 0"
        />
        <img
          src="@assets/images/two.png"
          class="numPic"
          v-if="isSort === true && index === 1"
        />
        <img
          src="@assets/images/three.png"
          class="numPic"
          v-if="isSort === true && index === 2"
        />
      </div>
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.store_name.replace('Double refund',$t('message.goods.name1'))
            .replace('Cash x2 returns',$t('message.goods.name2'))
            .replace('70 times refund(VIP1)',$t('message.goods.name3'))
            .replace('Cash x 72 returns',$t('message.goods.name4')) }}</div>
          <div class="money font-color-red">
            <span class="num">₫{{ parseInt(item.price)|MoneyFormat }}</span>
          </div>
          <div class="vip-money acea-row row-middle">
            <div class="vip" v-if="item.vip_price && item.vip_price > 0">
              ₫{{ parseInt(item.vip_price)|MoneyFormat}}<img src="@assets/images/vip.png" class="image" />
            </div>
            <span class="num">{{$t('message.detail.sold')}} {{ item.sales }}{{ item.unit_name }}</span>
          </div>
        </div>
      </div>
      <div class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"></div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  }
};
</script>
